import {
  UploadFileData,
  WorkData,
  WorkDetailSimpleData,
  WorkPropertyVisibleData,
  WorkSimpleForExportData,
  WorkSimpleForImportData,
} from '../dto/EntityRepository';

const EMPTY_UPLOAD_FILE: UploadFileData = {
  id: '',
  originUrl: '',
  allowDownload: false,
  width: 0,
  height: 0,
};

export const resolveUploadFileOriginUrl = (uploadFile?: UploadFileData | null): string =>
  uploadFile?.originUrl ?? '';

export const normalizeWorkDetailSimpleData = <T extends WorkDetailSimpleData>(detail: T): T => ({
  ...detail,
  description: detail.description ?? '',
  uploadFile: detail.uploadFile ?? EMPTY_UPLOAD_FILE,
});

export const normalizeWorkData = <T extends WorkData>(work: T): T => ({
  ...work,
  isPublic: work.isPublic !== false,
  titleEn: work.titleEn ?? '',
  materialEn: work.materialEn ?? '',
  descriptionEn: work.descriptionEn ?? '',
  sizeText: work.sizeText ?? '',
  description: work.description ?? '',
  material: work.material ?? '',
  prodYear: work.prodYear ?? '',
  collection: work.collection ?? '',
  duration: work.duration ?? '',
  videoUrl: work.videoUrl ?? '',
  sizes: work.sizes ?? [],
  credit: work.credit ?? null,
  artist: work.artist
    ? {
        name: work.artist.name ?? '',
        nameEn: work.artist.nameEn ?? '',
        linkedMemberAui: work.artist.linkedMemberAui ?? null,
        linkedMemberHandle: work.artist.linkedMemberHandle ?? null,
      }
    : null,
});

export const normalizeWorkSimpleData = <T extends WorkSimpleForImportData>(work: T): T => ({
  ...work,
  titleEn: work.titleEn ?? '',
  materialEn: work.materialEn ?? '',
  sizeText: work.sizeText ?? '',
  uploadFile: work.uploadFile ?? EMPTY_UPLOAD_FILE,
  artist: work.artist
    ? {
        name: work.artist.name ?? '',
        nameEn: work.artist.nameEn ?? '',
        linkedMemberAui: work.artist.linkedMemberAui ?? null,
        linkedMemberHandle: work.artist.linkedMemberHandle ?? null,
      }
    : null,
});

export const normalizeWorkSimpleForExportData = <T extends WorkSimpleForExportData>(work: T): T => ({
  ...work,
  sizeText: work.sizeText ?? '',
  artist: work.artist
    ? {
        name: work.artist.name ?? '',
        nameEn: work.artist.nameEn ?? '',
        linkedMemberAui: work.artist.linkedMemberAui ?? null,
        linkedMemberHandle: work.artist.linkedMemberHandle ?? null,
      }
    : null,
});

export const normalizeWorkPropertyVisible = (
  data: WorkPropertyVisibleData,
): WorkPropertyVisibleData => ({
  ...data,
  engVisible: data.engVisible !== false,
});
